import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol, MasterPageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { getUrlPageId, getDefaultMapping, buildCustomizedUrl, getCustomizedUrlSegments } from '@wix/url-mapper-utils'
import { isUrlCustomized } from '@wix/thunderbolt-commons'
import type { CustomUrlMapperSiteConfig, CustomUrlMapperMasterPageConfig, ICustomUrlMapper } from './types'
import { name } from './symbols'

const customUrlMapperFactory = (
	{ urlMappings, baseUrl }: CustomUrlMapperSiteConfig,
	masterPageConfig: CustomUrlMapperMasterPageConfig
): ICustomUrlMapper => {
	return {
		urlMappings,
		getUrlPageRoute(routes, url = '') {
			const { appPageIds } = masterPageConfig
			const resolvedPageId = getUrlPageId(urlMappings, appPageIds, url)
			return Object.keys(routes).find((key: string) => {
				const isPageIdInRoutes = routes[key].pageId === resolvedPageId
				const isPageIdInVariations = routes[key].pageIds?.includes(resolvedPageId)
				return isPageIdInRoutes || isPageIdInVariations
			})
		},
		buildDefaultUrl(url, pathPrefix) {
			const { key, segments } = getCustomizedUrlSegments(urlMappings, url) || {}
			if (key && segments) {
				const defaultMapping = getDefaultMapping(key, pathPrefix)

				const urlMapping = {
					main: [
						{
							key,
							mapping: defaultMapping,
						},
					],
				}
				return './' + (buildCustomizedUrl(urlMapping, key, segments) ?? url).replace(/^(\.\/|\/)+/, '')
			}
			return url
		},
		getIsUrlCustomized(url) {
			return isUrlCustomized(url, baseUrl, urlMappings)
		},
	}
}

export const CustomUrlMapper = withDependencies(
	[named(SiteFeatureConfigSymbol, name), named(MasterPageFeatureConfigSymbol, name)],
	customUrlMapperFactory
)
